<!-- DAppRow，展示DApp完整信息，响应式，大屏展示为长条或卡片，小屏展示为卡片 -->

<template>
  <a class="dapp-row">
    <div class="dapp-row-container box-shadow-light" @click="handleClick">
      <!--['index', 'name', 'category', 'user1d', 'tx1d', 'value1d', 'tx7d', 'value7d']-->

      <div class="dapp-row-index"><span>{{ dapp.index || 0 }}</span></div>
      <div class="dapp-row-basic">
        <SimpleImage class="dapp-row-logo" :src="dapp.logo" :placeholder="require('../static/round.png')"/>
        <span class="dapp-row-name">{{ dapp.name }}</span>
      </div>
      <div class="dapp-row-category"><span>{{ dapp.category.name }}</span></div>

      <div class="dapp-row-statistics dapp-row-statistics-integer"><span>{{ intValue(dapp.user1d) }}</span></div>
      <div class="dapp-row-statistics dapp-row-statistics-integer"><span>{{ intValue(dapp.tx1d) }}</span></div>
      <div class="dapp-row-statistics dapp-row-statistics-decimal"><span>{{ decimalValue(dapp.value1d) }}</span></div>

      <div class="dapp-row-statistics dapp-row-statistics-integer"><span>{{ intValue(dapp.user7d) }}</span></div>
      <div class="dapp-row-statistics dapp-row-statistics-integer"><span>{{ intValue(dapp.tx7d) }}</span></div>
      <div class="dapp-row-statistics dapp-row-statistics-decimal"><span>{{ decimalValue(dapp.value7d) }}</span></div>
    </div>
  </a>
</template>

<script>
  import SimpleImage from './SimpleImage'
  import * as router from '../router'

  export default {
    name: 'DAppRow',
    components: {SimpleImage},
    props: ['dapp'],
    methods: {
      handleClick () {
        router.navigateToDApp(this.dapp)
      },
      intValue (value) {
        return value || 0
      },
      decimalValue (value) {
        if (value) {
          if (value >= 1e6) { // 大于等于1e6的直接显示
            return value
          } else { // 否则取6位有效数字，并去掉末尾多余的0
            return parseFloat(value.toPrecision(6))
          }
        }
        return 0
      }
    }
  }
</script>

<style lang="scss">
  @import "../utils";

  .dapp-row {
    display: block;
  }

  .dapp-row-container {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    background: white;
    height: 60px;
    padding: 10px 20px;

    > * {
      @include flex-weighted;
      @include flex-horizontal;
      align-items: center;
      min-height: 100%;
      height: 100%;
      padding-left: 15px;
      padding-right: 15px;

      &:not(:last-child) {
        border-right: 1px solid #cccccc;
      }
    }
  }

  .dapp-row-index {
    @extend .single-line;
    flex-grow: 0.3;
    justify-content: center;
  }

  .dapp-row-basic {
    flex-grow: 2;
  }

  .dapp-row-logo {
    width: 30px;
    height: 30px;
  }

  .dapp-row-name {
    @extend .single-line;
    font-weight: bold;
    margin-left: 10px;
  }

  .dapp-row-category {
    @extend .single-line;
    justify-content: center;
  }

  .dapp-row-statistics {
    @extend .single-line;
    justify-content: flex-end;
  }

</style>



// WEBPACK FOOTER //
// src/widgets/DAppRow.vue